<template>
  <input class="slider" type="range" :value="modelValue" :min="min" :max="max" :step="step"
    @input="emits('update:modelValue', ($event.target as HTMLInputElement).valueAsNumber)"
    @change="emits('change')"  tabindex="-1">
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  modelValue: number,
  min?: number,
  max?: number,
  step?: number,
}>(), {
  min: 0,
  max: 100,
  step: 1
})

const emits = defineEmits<{
  (event: 'update:modelValue', value: number): void
  (event: 'change'): void
}>()

const valueAsPercentage = computed(() => (props.modelValue - props.min) / (props.max - props.min) * 100 + '%')
</script>

<style lang="scss">
.slider {
  -webkit-appearance: none;
  background-color: rgba($purple, 50%);
  background-image: linear-gradient($purple, $purple);
  background-size: v-bind(valueAsPercentage) 100%;
  background-repeat: no-repeat;
  cursor: pointer;

  &:disabled  {
    background-color: rgba($grey-80, 50%);
    background-image: linear-gradient($grey-80, $grey-80);
    background-size: v-bind(valueAsPercentage) 100%;

    &::-webkit-slider-thumb {
      background-color: $grey-60;
    }
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 24px;
    width: 24px;
    border-radius: 50%;
    background-color: $white;
    box-shadow: 0 0 2px 0 #555;
  }
}

</style>
